export default function AppDownload() {
    return (
        <section className='top-space py-[60px] lg:py-[120px] bg-[#161616]'>
          <h2 className='px-[5%] text-center text-title2 lg:text-display2 text-white'>
            제품과 함께 사용하는 필수 앱<br/>
            지금 설치해 보세요.
          </h2>

          <div className='mt-[50px]'>
            <a 
            href='https://play.google.com/store/apps/details?id=com.modulelink.linkcall&pcampaignid=web_share'
            aria-label=''
            >
              <div
                className='w-[200px] mx-auto py-[25px] px-[50px] rounded-[50px] bg-[#262626]'
              >
                <img
                  className='w-[119px]'
                  src={`${process.env.REACT_APP_STATIC_URL}/images/main/playstore.png`}
                />
              </div>
            </a>
          </div>
          
        </section>
    )
}